import { render, staticRenderFns } from "./SalaryInstitute.vue?vue&type=template&id=05ca1fee&scoped=true"
import script from "./SalaryInstitute.vue?vue&type=script&lang=js"
export * from "./SalaryInstitute.vue?vue&type=script&lang=js"
import style0 from "./SalaryInstitute.vue?vue&type=style&index=0&id=05ca1fee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ca1fee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05ca1fee')) {
      api.createRecord('05ca1fee', component.options)
    } else {
      api.reload('05ca1fee', component.options)
    }
    module.hot.accept("./SalaryInstitute.vue?vue&type=template&id=05ca1fee&scoped=true", function () {
      api.rerender('05ca1fee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/SalaryInstitute.vue"
export default component.exports